module.exports = __webpack_public_path__ + "img/Portugal.07df6c28.gif";